<template>
  <div class="home net-status-home">
    <Layout
      layoutType="HARDLIST"
      isRevenue="true"
      :pageTitle="$t('menu.taskStatus')"
    >
      <BasiceLayout :title="$t('menu.calTaskStatus')">
        <div class="hardware-content">
          <!-- mac地址搜索 -->
          <div
            class="hardware-search-wrap"
            v-if="allDevices"
            align='center'
          >
            <span class="search-text">{{$t('mac_address')}}</span>
            <el-input class="search-mac-input" v-model="searchMacAddress" placeholder="" @change="search"></el-input>
          </div>
          <!-- 硬件列表 -->
          <el-table
            v-if="hardList !== 'NO_CONTENT'"
            :data="hardList"
            align="left"
            empty-text="Loading..."
            style="width: 100%"
            fit="true"
            @sort-change="sortDevices"
          >
            <!-- mac address -->
            <el-table-column
              prop="mac_address"
              :label="$t('macAddress')"
              align='center'
            >
            </el-table-column>
            <!-- 备注 -->
            <el-table-column
              :label="$t('noteText')"
              align='center'
              sortable="custom"
            >
              <template slot-scope="scope">
                <div v-if="scope.row.note">{{scope.row.note}}</div>
                <div
                  v-if="!scope.row.note"
                  :deviceId="scope.row.deviceId"
                  @click="showNotes(scope.row.id, scope.row.mac_address)"
                  class="add-note-button button bonus-cursor"
                >
                  {{$t('addNote')}}</div>
                <i
                  v-if="scope.row.note && scope.row.noteStatus"
                  class="el-icon-edit"
                  @click="showNotes(scope.row.id, scope.row.mac_address)"
                ></i>
              </template>
            </el-table-column>
            <!-- cpu -->
            <el-table-column :label="$t('CPU')" align='center'>
              <template slot-scope="scope">
                <div v-if="scope.row.cpu_count">{{scope.row.cpu_count}}</div>
                <div v-else>-</div>
              </template>
            </el-table-column>
            <!-- 内存 -->
            <el-table-column
              prop=""
              :label="$t('mem_size')"
              align='center'
            >
              <template slot-scope="scope">
                <div v-if="scope.row.mem_size">{{scope.row.mem_size}}</div>
                <div v-else>-</div>
              </template>
            </el-table-column>
            <!-- 硬盘 -->
            <el-table-column
              prop=""
              :label="$t('storage_size')"
              align='center'
            >
              <template slot-scope="scope">
                <div v-if="scope.row.storage_size">{{scope.row.storage_size}}</div>
                <div v-else>-</div>
              </template>
            </el-table-column>
            <!-- 同步数据总量  -->
            <el-table-column
              :render-header="renderHeader"
              :label="$t('totalCache')"
              align='center'
              min-width="120px"
            >
              <template slot-scope="scope">
                <span v-if="scope.row.used_ext_storage_size">{{scope.row.used_ext_storage_size}}</span>
                <span v-else>-</span>
              </template>
            </el-table-column>
            <!-- 网络穿透 -->
            <el-table-column
              :render-header="renderHeader"
              :label="$t('networkPenetration')"        
              align='center'
              min-width="120px"
            >
              <template slot-scope="scope">
                <!--  -->
                <el-popover
                  placement="top-start"
                  width="300"
                  trigger="hover">
                  <div>
                    <div>{{ $t('nat_type') }}: {{ $t(`nat_${scope.row.nat}`) || '-' }}</div>
                    <div>{{ $t('nat_time') }} : {{ scope.row.nat_upd_at }}</div>
                    <div v-if='scope.row.portmap === "NAT-PMP" || scope.row.portmap === "UPNP"'>UPNP：{{ $t(`upnp_open`) }}</div>
                    <div v-else-if='scope.row.portmap === "int-ip"'>UPNP：{{ $t(`upnp_intip`) }}</div>
                    <!-- <div v-else>UPNP：{{ $t(`upnp_close`) }}</div> -->
                    <!-- <div>{{ $t('upnp_time') }}：{{ scope.row.portmap_upd_at}}</div> -->
                  </div>
                  <el-tag 
                    v-if="(scope.row.portmap === 'NAT-PMP' || scope.row.portmap === 'UPNP' || scope.row.nat === 3 || scope.row.nat === 2)"
                    type="success"
                    slot="reference"
                  >{{$t('OnDispatch')}}</el-tag>
                  <el-tag 
                    v-if="!(scope.row.portmap === 'NAT-PMP' || scope.row.portmap === 'UPNP' || scope.row.nat === 3 || scope.row.nat === 2)"
                    slot="reference"
                    type="warning"
                  >{{$t('OffDispatch')}}</el-tag>
                </el-popover>
              </template>
            </el-table-column>
            <!-- 是否已被调度 -->
            <el-table-column
              :render-header="renderHeader"
              :label="$t('scheduleStatus')"              
              align='center'
            >
              <template slot-scope="scope">
                <div v-if="!scope.row.schedule">不支持调度
                  <el-popover placement="bottom" width="200" trigger="hover" content="请检查设备DNS，并调整为223.5.5.5后重启">
                    <i class="el-icon-warning" slot="reference"></i>
                  </el-popover>
                </div>
                <div v-if="scope.row.schedule">
                  <div v-if="scope.row.last_manual_schedule_status ==='process'">调度处理中，请等待
                    <el-popover placement="bottom" width="200" trigger="hover" content="若2小时内未完成，请尝试重启后等待，若长期未生效，使用最新镜像重刷">
                      <i class="el-icon-warning" slot="reference"></i>
                    </el-popover>
                  </div>
                  <div v-if="scope.row.last_manual_schedule_status ==='vol_ins'">调度失败
                    <el-popover placement="bottom" width="200" trigger="hover" content="硬盘空间不足，请格盘或更换硬盘">
                      <i class="el-icon-warning" slot="reference"></i>
                    </el-popover>
                  </div>
                  <div v-if="scope.row.last_manual_schedule_status ==='applied'"> 
                    <div v-if="scope.row.task_status ==='Pending'">等待任务启动</div>
                    <div v-if="scope.row.task_status ==='NotRunning'">任务运行失败
                      <el-popover placement="bottom" width="200" trigger="hover" content="请前往微信“博纳云”工单小程序提交工单反馈">
                        <i class="el-icon-warning" slot="reference"></i>
                      </el-popover>
                    </div>
                    <div v-if="scope.row.task_status ==='Running'">任务正常运行</div>
                  </div>
                </div>
              </template>
            </el-table-column>
            <!-- 当前任务 -->
             <el-table-column
              :label="$t('currentRunningTask')"        
              align='center'
            >
              <template slot-scope="scope">
                <div v-if="scope.row.task_map && scope.row.task_map.length" v-for="(item, index) in scope.row.task_map">
                  <span>{{ item.task }} </span>
                </div>
                <div v-else>-</div>
              </template>
                
            </el-table-column>
            <!-- 监测 -->
            <el-table-column
              prop=""
              :label="$t('watch')"
              align='center'
            >
              <template slot-scope="scope">
                <img
                  class="watch-icon"
                  @click="showWatchDetail('id', scope.row.id, scope.row.info)"
                  src="../../../assets/hardList/watch.png"
                >
              </template>
            </el-table-column>
          </el-table>
          <div
            class="pagination"
            v-if="deviceSize > 1"
          >
            <el-pagination
              @current-change="handleCurrentChange"
              :current-page.sync="currentPage"
              :page-size="deviceSize"
              layout="total, prev, pager, next"
              :total="hardLength"
            >
            </el-pagination>
          </div>
          <el-table
            v-if="hardList === 'NO_CONTENT'"
            :empty-text="$t('noHardwareTip')"
            style="width: 100%"
          >
          </el-table>
        </div>
         <el-dialog
          :title="$t('watchDetail.title')"
          :visible.sync="showWatchDialog"
          width="60%"

        >
          <div class="watch-dialog-wrap">
            <span class="key"></span>
            <div class="watch-select">
              <span class="search-text">{{$t('watchDetail.watchDate')}}:</span>
              <el-select
                v-model="searchWatchDate"
                filterable
                @change="showWatchDetail"
              >
                <el-option
                  v-for="item in watchQueryDate"
                  :key="item"
                  :label="item"
                  :value="item"
                >
                </el-option>
              </el-select>
            </div>
            <div v-loading="chartLoading" style="min-height: 400px;">
              <div v-if="showCharts">
                <ve-line
                  class="watch-chart"
                  :data="useBandCharts"
                ></ve-line>
              </div>
              <div
                v-if="!showCharts"
                class="no-watch-data"
              >{{$t('watchDetail.noData')}}</div>
            </div>
          </div>
        </el-dialog>
      </BasiceLayout>
    </Layout>
    <!-- 增加备注 -->
    <el-dialog
      :title="$t('addNotes.title')"
      :visible.sync="showAddnoteDialog"
      width="480px"
      center
    >
      <div class="addnote-dialog-wrap">
        <span class="key">{{$t('addNotes.tipText')}}({{addNoteAddress}})</span>
        <input
          type="text"
          class="basic-input input addnote-input"
          v-model="addNoteInput"
        >
      </div>
      <span
        slot="footer"
        class="dialog-footer"
      >
        <div
          class="sure-unbind button"
          @click="showAddnoteDialog = false"
        >{{ $t('cancel') }}</div>
        <div
          class="sure-unbind button"
          type="primary"
          @click="addNote"
        >{{ $t('confirm') }}</div>
      </span>
    </el-dialog>
  </div>
</template>

<i18n>
{
  "en": {
    "macAddress": "MAC Address",
    "location": "Area",
    "stable": "Stability",
    "needs": "Node Demand",
    "code": "Binding BonusCode",
    "totalTime": "Total Online Time",
    "netStatus": "Status",
    "needsHigh": "High",
    "needsMiddle": "Medium",
    "needsLow": "Low",
    "stableHigh": "High",
    "stableMiddle": "Medium",
    "stableLow": "Low",
    "mac_address": "Search Mac Address",
    "CPU": "CPU",
    "storage_size": "Storage",
    "tx_bw": "Upstream Bandwidth",
    "addNotes": {
      "title": "Add device note",
      "tipText": "Enter the name of the note you want to record for the device:"
    },
    "noteText": "note",
    "allSearch": "All",
    "scheduleFalse": "No",
    "scheduleSuccess": "Yes",
    "nat": "NAT Type",
    "UPNP_ON": "On",
    "UPNP_OFF": "Off",
    "UPNP_IN": "int-ip",
    "networkPenetration": "Network Penetration",
    "OnDispatch": "ON",
    "OffDispatch": "OFF",
    "totalCache": "Total Cache",
    "nat_type": "NAT Type",
    "nat_time": "NAT Update Time",
    "upnp_time": "UPNP Update Time",
    "upnp_open": "Open",
    "upnp_close": "Close",
    "upnp_intip": "INT_IP",
    "noSchedule": "The device does not support scheduling now" ,
    "noScheduleTips": "Please check whether DNS is resolved correctly.",
    "currentRunningTask": "Current running task"     
  },
  "zn": {
    "macAddress": "硬件MAC地址",
    "location": "所在地区",
    "stable": "节点网络质量",
    "needs": "当前地区节点需求度",
    "code": "已绑定激活码 ",
    "totalTime": "累计在线时长",
    "netStatus": "在线状态",
    "needsHigh": "高",
    "needsMiddle": "中",
    "needsLow": "低" ,
    "stableHigh": "高",
    "stableMiddle": "中",
    "stableLow": "低",
    "mac_address": "Mac地址搜索",
    "addNotes": {
      "title": "添加设备备注",
      "tipText": "输入该设备记录的备注名："
    },
    "noteText": "备注",
    "allSearch": "全部",
    "scheduleSuccess": "是",
    "scheduleFalse": "否",
    "CPU": "CPU",
    "tx_bw": "上行带宽",
    "storage_size": "硬盘",
    "nat": "NAT 类型",
    "stable": "网络资源可用性",
    "UPNP_ON": "开启",
    "UPNP_OFF": "关闭",
    "UPNP_IN": "内网IP",
    "networkPenetration": "网络穿透",
    "OnDispatch": "正常",
    "OffDispatch": "不正常",
    "totalCache": "同步数据总量",
    "nat_type": "NAT类型",
    "nat_time": "NAT更新时间",
    "upnp_time": "UPNP更新时间",
    "upnp_open": "开启",
    "upnp_close": "关闭",
    "upnp_intip": "内网IP",
    "currentRunningTask": "当前运行任务"     
  }
}
</i18n>


<script>
// @ is an alias to /src
import { mapState, mapActions, mapMutations } from "vuex";
import BasiceLayout from "@/components/Common/BasicLayout.vue";
import AccountSetLayout from "@/components/AccountSet/AccountSetLayout.vue";
import HardwareLayout from "@/components/Hardware/HardwareLayout.vue";
import SendEmailCode from "@/components/SendEmailCode.vue";
import moment from "moment";
import { Message } from "element-ui";
import { LANG } from "../../../config/contant.js";
import Layout from "@/components/DatePanel/Layout.vue";
import { getCookie } from "@/utils/utils";
import { BytesToM, toFixed } from "@/utils/utils";

export default {
  name: "home",
  components: {
    BasiceLayout,
    AccountSetLayout,
    SendEmailCode,
    HardwareLayout,
    Layout
  },
  data() {
    return {
      showAddnoteDialog: false, //添加备注
      addNoteInput: "",
      addNoteId: "", //添加备注Id
      addNoteAddress: "", //添加备注Id
      ticket: "", // 验证码ticket
      searchMacAddress: "",
      showWatchDialog: false, //监控弹框
      showCharts: "waiting",
      chartLoading: false,
      useBandCharts: {},
      searchWatchDate: moment()
        .utc()
        .startOf("day")
        .subtract(1, "days")
        .format("YYYY-MM-DD"),
    };
  },
  computed: mapState({
    isZnWebsite: state => state.isZnWebsite,
    hardList(state) {
      if (!!state.hardWare.list && !!state.hardWare.list.length && state.hardWare.list !== 'NO_CONTENT') {
        return state.hardWare.list.map(item => {
          if (item.task_solution === 'system') {
            item.scheduleError = !this.isZnWebsite ?'Automatically repairing, waiting for rescheduling.' : '自动修复中，等待重新调度。';
          } else if (item.task_solution === 'network_check') {
            item.scheduleError = !this.isZnWebsite ? 'Network failure, please check the network.' : '网络故障，请检查网络。';
          } else if (item.task_solution === 'os_rebuild') {
            item.scheduleError = !this.isZnWebsite ? 'System failure, please flash again.' : '系统故障，请重新刷机。';
          } else if (item.task_solution === 'hd_format') {
            item.scheduleError = !this.isZnWebsite ? 'The hard disk is faulty. Please format the hard disk to ext4 format.' : '硬盘故障，请格式化硬盘为ext4格式。';
          } else {
            item.scheduleError = !this.isZnWebsite ? 'The question is pending, please join the group to contact the official staff.' : '问题待定，请前往微信“博纳云”工单小程序提交工单反馈。';
          }

          return item;
        });
      } else {
        return state.hardWare.list;
      }
    },
    hardLength: state => state.hardWare.hardLength,
    deviceSize: state => state.hardWare.deviceSize,
    currentPage: state => state.hardWare.currentPage,
    email: state => state.account.email,
    allDevices: state => state.hardWare.allDevices,
    // 监控查询过去30天时间
    watchQueryDate: () => {
      let watchQueryDate = [];
      let endDay = moment()
        .startOf("day");
        
      let i = 0;
      while (i < 30) {
        i++;
        watchQueryDate.push(moment(endDay).format("YYYY-MM-DD"));
        endDay -= 24 * 60 * 60 * 1000;
      }

      return watchQueryDate;
    }
  }),
  methods: {
    ...mapActions([
      "getHardList",
      "unbindHard",
      "getDeviceDetail",
      "addDeviceNotes",
      "getDevicePcdnFlow"
    ]),
    showWatchDetail(type, id, info) {
      let that = this;
      this.useBandCharts = {};
      this.showCharts = "waiting";
      this.showWatchDialog = true;
      let queryDate = this.searchWatchDate;
      this.watchId = type === "id" ? id : this.watchId;
      let date_after = moment(queryDate).utc().valueOf();
      let date_before = date_after + 86400000;

      // 处理参数
      if (id) {
        that.useBandInfo = info;
        that.useBandDeviceId = id;
      } else {
        info = this.useBandInfo;
        id = this.useBandDeviceId;
      }

      // 表提示内容
      let watchStable = this.$t("watchDetail.watchStable");
      let watchAvaliable = this.$t("watchDetail.watchAvaliable");
      let watchStorge = this.$t("watchDetail.watchStorge");
      let watchDate = this.$t("watchDetail.watchDate");
      let watchUseBand = this.$t("usedBand");
      this.chartLoading = true;
      // 查询设备实际带宽
      this.getDevicePcdnFlow({
        info,
        device_id: id,
        flow_user: "total",
        date_before,
        date_after
      }).then(res => {
        this.chartLoading = false;
        if (res && res.device_pcdnflow_logging && res.device_pcdnflow_logging.length) {
           // 判断是否dcache设备
          let isDcache = false;
          res.flow_users.map(item => {
            if (item.user_name === 'dcache') {
              isDcache = true;
            }
          })

          // 此处为了中英文对照，所以动态处理
          let useBandCharts = {
            columns: [],
            rows: []
          };

          useBandCharts.columns = [
            watchDate,
            watchUseBand,
          ];

          res.device_pcdnflow_logging.map(item => {
            let { time, diffBps, out_bps } = item;
            let value = isDcache ? diffBps : out_bps;
            let date_at = moment(new Date(time)).format("YYYY-MM-DD HH:mm:ss");
            let useBandRows = [];
            // 日期处理
            useBandRows[watchDate] = date_at;
            useBandRows[watchUseBand] = toFixed(
              BytesToM(value)
            );

            useBandCharts.rows.push(useBandRows);
          });

          that.useBandCharts = useBandCharts;
          that.showUseBandCharts = true;
        } else {
          this.showCharts = '';
          that.showUseBandCharts = false;
        }
      });
    },
    change() {
      this.changePw({
        oldPassword: this.oldPw,
        newPassword: this.newPw,
        reNewPassword: this.newSecPw
      });
    },
    renderHeader: function(creatElement, { column, $index }) {

      let fields = this.fields;
      return creatElement("div", [
        column.label,
        creatElement(
          "el-tooltip",
          {
            class: "cell-s-tip",
            props: {
              content: (function() {
                let label = column.label;
                switch (label) {
                  case "是否已被调度":
                    return "已调度的设备需要3-4天同步数据后才能稳定运行，请保持设备在线；调度失败的设备需要将硬盘重新格式化后再插入并等待重新调度。";
                    break;
                  case "Scheduling Status":
                    return "Since it takes 3 - 4 days for the scheduled devices to run in a stable status after the data synchronization, please keep the devices online. Please reformat the hard drive of the devices that fail to be scheduled and insert it again to await for the rescheduling.";
                    break;
                  case "网络穿透":
                    return `网络穿透正常才能稳定的获得最佳计算任务收益，当 NAT 类型为 NAT1 或 UPNP 为开启时，网络才可以正常穿透。关于网络穿透参考i首页公告帮助文档`;
                    break;
                  case "Network Penetration":
                    return "Only when the devices with NAT traversal are in normal status, users can get the computing task revenue at optimum. And only when the NAT type is NAT1 or the UPNP is on, the network can successfully traverse.";
                    break;
                  case "计算任务调度":
                    return "是否可被调度表示设备是否正常连接到计算任务调度服务器，若该状态为否，则会导致设备无法正常运行计算任务，需要排查DNS解析是否有误。";
                    break;
                  case "Computing Task Scheduling":
                    return `The schedulability refers to the status of the device connected into the computing task scheduling server. If the status is "not schedulable", it means that the corresponding device cannot run computing task normally, please check whether DNS is resolved correctly.`;
                    break;
                  case "同步数据总量":
                    return `同步数据总量超过30G才能正常使用带宽资源。若同步数据较多但使用流量少，请检查设备UPNP是否正常开启，或配置DMZ。`;
                    break;
                  case "Total Cache":
                    return `Only when the total synchronized data exceeds 30G can the bandwidth resources be used properly. If there are more synchronized data but the used traffic is less , please check whether UPNP is turned on properly or configure DMZ.`
                    break;
                }
              })(),
              effect: "dark",
              placement: "top"
            }
          },
          [
            creatElement("i", {
              class: "fa fa-question-circle revenue-icon el-icon-question"
            })
          ]
        )
      ]);
    },
    // 添加备注
    addNote() {
      let that = this;
      if (!this.addNoteInput) {
        return;
      }
      this.addDeviceNotes({
        deviceId: this.addNoteId,
        note: this.addNoteInput
      }).then(res => {
        if (res.code === 200) {
          Message({
            type: "success",
            message: res.message
          });
          that.showAddnoteDialog = false;
          if (that.searchMacAddress === "all" || that.searchMacAddress === "") {
            that.getHardList({
              pageNum: that.currentPage,
              type: "compute",
              deviceType: "lite"
            });
          } else {
            this.getDeviceDetail({ id: that.searchMacAddress, type: 'compute' });
          }
        } else {
          Message({
            type: "error",
            message: res.message || "add note error"
          });
        }
      });
    },
    showNotes(id, address) {
      this.showAddnoteDialog = true;
      this.addNoteId = id;
      this.addNoteAddress = address;
    },
    // 搜索
    search() {
      this.getDeviceDetail({ macAddress: this.searchMacAddress, type: 'compute' });
    },
    // 分页
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getHardList({ pageNum: val, type: "compute", filterType: 'calculate', deviceOrder: this.deviceOrder, deviceType: "lite" });
    },
    // 排序
    sortDevices() {
      let { currentPage } = this;
      let deviceOrder = 'note';
      this.deviceOrder = deviceOrder;
      this.getHardList({ pageNum: currentPage, deviceOrder, type: "compute", filterType: 'calculate', deviceType: "lite" });
    },
  },
  created() {
    this.getHardList({ pageNum: 1, type: "compute", filterType: 'calculate', deviceType: "lite" });
  }
};
</script>

<style lang="stylus">
.pagination {
  margin: 20px;
}

.hardware-search-wrap {
  text-align: left;
  margin-bottom: 20px;
  padding-bottom: 30px;
  border-bottom: 1px solid #ddd;
}

.search-text {
  margin: 0 20px;
  display: inline-block;
}

.addnote-input {
  width: 100%;
  margin-top: 20px;
}

.add-note-button {
  background: #909399;
  color: #fff;
  width: 110px;
  height: 35px;
  line-height: 35px;
  text-align: center;
  margin: 0;
  width: 100%;
}

.net-status-home.home {
  height: auto !important;
}

.el-table th div {
  overflow: initial !important;
}

.watch-dialog-wrap{
  width: 100%;
}

</style>
